import { appendQuery } from './appendQuery';
import { buildQueryPath } from './buildQueryPath';
export function appendQueryParams(url, params, disableEncodedOutput) {
    if (!url) {
        return url;
    }
    return appendQuery(url, buildQueryPath(params, disableEncodedOutput));
}
//# sourceMappingURL=appendQueryParams.js.map